// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const CheckCircleFilled = createIcon(
  <path
    clipRule="evenodd"
    d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM18.2739 8.82972C18.6254 8.47824 18.6254 7.90839 18.2739 7.55693C17.9224 7.20546 17.3526 7.20547 17.0011 7.55694L10.1631 14.3951L6.99871 11.2306C6.64724 10.8792 6.07739 10.8792 5.72591 11.2306C5.37444 11.5821 5.37443 12.1519 5.7259 12.5034L9.52671 16.3043C9.69549 16.4731 9.92441 16.5679 10.1631 16.5679C10.4018 16.5679 10.6307 16.4731 10.7995 16.3043L18.2739 8.82972Z"
    fillRule="evenodd"
  />,
);
